module.exports = __webpack_public_path__ + "fonts/5e55e037f1e2b655aa6d336c36586ab7.eot";